/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Identifies contact type to include with response
 * @export
 * @enum {string}
 */
export enum IncludeContactType {
    None = 'none',
    Primary = 'primary',
    All = 'all'
}


export function IncludeContactTypeFromJSON(json: any): IncludeContactType {
    return IncludeContactTypeFromJSONTyped(json, false);
}

export function IncludeContactTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncludeContactType {
    return json as IncludeContactType;
}

export function IncludeContactTypeToJSON(value?: IncludeContactType | null): any {
    return value as any;
}

